import { ActionType, createReducer } from 'typesafe-actions'

import * as Actions from './actions'
import { IssuancesState } from './types'

const INITIAL_STATE: IssuancesState = {
  error: '',
  filterOrganizationsId: '',
  filterRequestNumber: '',
  filterRequestTitle: '',
  filterStatus: [],
  filterTenantId: '',
  list: [],
  loading: false,
  organizations: [],
  request_totals: {
    total_emissions: 0,
    total_quotations: 0
  },
  sendIssuanceError: '',
  sendIssuanceLoading: false,
  ticketsEmission: [],
  total_results: 0
}

const reducer = createReducer<IssuancesState, ActionType<typeof Actions>>(
  INITIAL_STATE
)
  .handleAction(Actions.getIssuances, (state, { payload }) => ({
    ...state,
    filterOrganizationsId:
      payload.options.filterOrganizationsId ?? state.filterOrganizationsId,
    filterRequestNumber:
      payload.options.request_numbers ?? state.filterRequestNumber,
    filterRequestTitle:
      payload.options.request_title ?? state.filterRequestTitle,
    filterStatus: payload.options.filterStatus ?? state.filterStatus,
    filterTenantId: payload.options.filterTenantId ?? state.filterTenantId,
    error: '',
    loading: true
  }))
  .handleAction(Actions.getIssuancesFailure, (state, { payload }) => ({
    ...state,
    error: payload.message,
    loading: false
  }))
  .handleAction(Actions.getIssuancesSuccess, (state, { payload }) => ({
    ...state,
    list: [...payload.requests],
    loading: false,
    organizations: payload.organizations,
    request_totals: { ...payload.request_totals },
    total_results: payload.total_results
  }))
  .handleAction(Actions.sendIssuance, state => ({
    ...state,
    sendIssuanceError: '',
    sendIssuanceLoading: true
  }))
  .handleAction(Actions.sendIssuanceFailure, (state, { payload }) => ({
    ...state,
    sendIssuanceError: payload.message,
    sendIssuanceLoading: false
  }))
  .handleAction(Actions.sendIssuanceSuccess, state => ({
    ...state,
    sendIssuanceLoading: false
  }))
  .handleAction(Actions.setTicketsEmission, (state, { payload }) => ({
    ...state,
    ticketsEmission: [...payload.ticketsEmission]
  }))

export default reducer
